import React from "react";
import SvgContainer from "src/components/SvgContainer";
import { Flex, Box } from "@chakra-ui/react";
import { BodyText2 } from "src/atoms/typography";
import Menu from "src/components/Menu";
import MenuItem from "src/components/Menu/Item";
import MenuItemText from "src/components/Menu/ItemText";
import CorrespondingAvatar from "src/modules/avatar/components/CorrespondingAvatar";
import { ReactComponent as ArrowDown } from "src/modules/parent-station/scenes/SelectBabyStation/arrow-down.svg";

export default class AvatarPicker extends React.Component {
  state = {
    isOpen: false
  };

  handleAvatarChange = (avatarId) => {
    this.props.handleAvatarChange(avatarId);
    this.setState({ isOpen: false });
  };

  openPicker = () => this.setState({ isOpen: true });
  closePicker = () => this.setState({ isOpen: false });

  render() {
    const { isOpen } = this.state;
    const { avatars, selectedAvatarId } = this.props;
    const avatarsArray = Object.values(avatars).filter(
      (avatar) => avatar.deleted === false
    );

    if (avatarsArray.length === 0 || avatars[selectedAvatarId] == null)
      return null;
    if (avatarsArray.length === 1)
      return (
        <BodyText2 color="mediumEmphasis">{avatarsArray[0].name}</BodyText2>
      );

    return (
      <>
        <Menu
          isOpen={isOpen}
          elevationLevel={2}
          onClose={this.closePicker}
          placement="top"
          contentProps={{
            overflowY: "scroll",
            maxHeight: "180px"
          }}
          // anchorOrigin={{
          //   vertical: "top",
          //   horizontal: "center"
          // }}
          // transformOrigin={{
          //   vertical: "top",
          //   horizontal: "center"
          // }}
          anchorEl={
            <Flex onClick={this.openPicker} alignItems="center">
              <BodyText2
                whiteSpace="nowrap"
                overflow="hidden"
                textOverflow="ellipsis"
                maxWidth="178px"
                pl="8px"
                fontSize={["1.2rem", "1.6rem", "1.8rem"]}
                color="mediumEmphasis"
              >
                {avatars[selectedAvatarId].name}
              </BodyText2>
              <SvgContainer
                icon={ArrowDown}
                size="16px"
                fill="mediumEmphasis"
              />
            </Flex>
          }
        >
          {avatarsArray.map((avatar) => (
            <MenuItem
              key={avatar.objectId}
              onClick={() => this.handleAvatarChange(avatar.objectId)}
            >
              <Box mr="16px">
                <CorrespondingAvatar
                  avatar={avatar}
                  width="24px"
                  height="24px"
                />
              </Box>
              <MenuItemText>{avatar.name}</MenuItemText>
            </MenuItem>
          ))}
        </Menu>
      </>
    );
  }
}
